import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { isDesktop } from "shared/util/EnvironmentHelpers";
import Link from "shared/components/Link";

import {
	FOOTER_SECTIONS,
	FOOTER_SECTION_LABELS,
	FOOTER_SECTION_LINKS,
} from "shared/components/Footer/constants";

import "./Section.scss";

if (process.env.PLATFORM === "mobile") {
	require("./Section.mobile.scss");
} else {
	require("./Section.desktop.scss");
}

const Section = ({ id, extraLinks }) => {
	const [isExpanded, setIsExpanded] = useState(isDesktop);

	const toggleIsExpanded = () => {
		if (isDesktop) {
			return;
		}

		setIsExpanded(!isExpanded);
	};

	return (
		<div className="footer-section">
			<button
				className={classnames("footer-section-title", {
					"footer-section-title--is-expanded": isExpanded,
				})}
				onClick={toggleIsExpanded}
			>
				{FOOTER_SECTION_LABELS[id]}
			</button>
			{isExpanded && (
				<div className="footer-section-links">
					{id === FOOTER_SECTIONS.SPECIAL && extraLinks.map((link) => link)}
					{FOOTER_SECTION_LINKS[id].map((link) => (
						<Link
							key={link.path}
							to={link.path}
							className="footer-section-link"
							noSpa={link.noSpa}
						>
							{link.label}
						</Link>
					))}
				</div>
			)}
		</div>
	);
};

Section.propTypes = {
	id: PropTypes.oneOf(Object.keys(FOOTER_SECTIONS)).isRequired,
	extraLinks: PropTypes.array.isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./src/shared/components/Footer/Section.jsx